<template>
    <template v-if="loading">
        <div class="card multisteps-form__panel p-3 border-radius-xl bg-white text-center" data-animation="FadeIn">
            <div class="d-flex justify-content-center mt-2">
                <p><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="card multisteps-form__panel p-3 border-radius-xl bg-white text-center" data-animation="FadeIn">
            <div>
                <div class="d-flex justify-content-center mt-2">
                    <i class="fa fa-calendar fa-8x segment-primary-color"></i>
                </div>
                <h5 class="d-flex justify-content-center mt-3 segment-primary-color">
                    {{ message }} <br>
                    {{ contractData ? contractData.nome + ' - ' + contractData.contrato_unidade : null }}
                </h5>

                <div v-if="authorization">
                    <div class="button-row d-flex mt-4 justify-content-center">
                        <argon-button type="button"
                            class="js-btn-next btn custom-btn bg-segment-primary-color align-items-center"
                            @click="handleNextClick">Agendar</argon-button>
                    </div>
                </div>
                <ScheduleHistory :schedulings="allSchedulings"></ScheduleHistory>
            </div>
        </div>
    </template>
</template>

<script setup>

import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import ArgonButton from "@/components/ArgonButton.vue";
import ScheduleHistory from './ScheduleHistory.vue'

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const loading = ref(false);
const error = ref();
const nextScheduling = ref();
const authorization = ref(false);
const releaseDate = ref(false);
const scheduleType = ref();
const allSchedulings = ref();
// const noSchedulings = ref(false);
const message = ref(null)

const emit = defineEmits(["nextStep", "prevStep"]);
onMounted(() => {
    getAuthorization();
    getClientSchedulings();
});

const getClientSchedulings = async () => {
    try {
        loading.value = true;
        const response = await axios.get(`/clients/scheduling/scheduling-salesforce/${contractData.value.contrato_id}`);
        nextScheduling.value = getNextSchedule(response.data.message)
        allSchedulings.value = response.data.message
    } catch (err) {
        loading.value = false;
        error.value = err.message;
    } finally {
        loading.value = false
    }
}


const getAuthorization = async () => {
    try {
        const response = await axios.get(`/clients/scheduling/salesforce/authorization/${contractData.value.contrato_id}/${contractData.value.id_empreendimento}`);

        authorization.value = response.data.authorization
        scheduleType.value = response.data.scheduleType
        releaseDate.value = response.data.releaseDate

        if (authorization.value) {
            message.value = `A ${response.data.scheduleType} do seu empreendimento está liberada`
        } else if(!releaseDate.value) {
            message.value = `A Visita do seu empreendimento não está liberada`
        } else if (releaseDate.value) {
            message.value = `A Visita da sua unidade está liberada a partir de ${releaseDate.value}`
        }
    } catch (err) {
        error.value = err.message;
    } finally {
        //
    }
}

const handleNextClick = () => {
    let schedulingConfig = {
        scheduleType: scheduleType.value
    };

    emit('nextStep', schedulingConfig);
};

const getNextSchedule = (schedulings) => {
    return schedulings
        .filter(({ status, schedulingDate }) => status === "Confirmado" && new Date(schedulingDate) > new Date())
        .sort((a, b) => new Date(a.schedulingDate) - new Date(b.schedulingDate))[0] || null;
}

</script>